import React from 'react';
import { Link } from 'gatsby';

import Layout from '../components/Layout';
import SEO from '../components/seo';
import PostList from '../components/PostList';
import Sidebar from '../components/Sidebar';
import { categoryPermalink } from '../utils/categories';

import './blog-posts-pagination.css';

export default function BlogPostsPagination({ data, pageContext: { category } }) {
  const posts = data.allMarkdownRemark.edges;

  const pathname = category ? categoryPermalink(category) : '/';

  return (
    <Layout className="blogPosts">
      <SEO
        title={category ? `Posts: ${category}` : 'Backstage Blog'}
        pathname={pathname}
      />

      <header className="blogPosts__hero">
        <h1 className="blogPosts__title">Backstage Blog</h1>
      </header>

      <div className="blogPosts__grid">
        <div className="blogPosts__sidebar">
          <Sidebar />
        </div>
        <div className="blogPosts__main">
          <PostList posts={posts} activeCategory={category} />
          {category && (
            <div className="blogPosts__clearFilter">
              <Link to="/" className="blogPosts__clearFilterBtn">
                Clear filter
              </Link>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
